exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.addgallery .el-dialog__body {\n  text-align: center;\n}\n/* .addgallery .el-upload-list {\n    display: none;\n} */\n", ""]);

// exports
